import React from 'react';
import type { AiCaptainDealItem } from '../../utils/aiCaptainDeals';
import { formatDealMeta } from '../../utils/aiCaptainDeals';

const BILLING_NOTE =
  'Coupons cannot be applied here. Tell your captain the coupon code when you request the bill.';

interface CaptainDealCardsProps {
  deals: AiCaptainDealItem[];
}

const CaptainDealCards: React.FC<CaptainDealCardsProps> = ({ deals }) => {
  if (deals.length === 0) return null;

  return (
    <div className="vc-deal-cards-wrap">
      <div className="vc-deal-cards" role="list" aria-label="Available deals">
        {deals.map((deal) => (
          <article key={deal.id} className="vc-deal-card" role="listitem">
            <div className="vc-deal-card__icon" aria-hidden>
              {deal.kind === 'coupon' ? '🏷️' : '🎁'}
            </div>
            <div className="vc-deal-card__body">
              <div className="vc-deal-card__title">{deal.title}</div>
              {deal.description && <p className="vc-deal-card__desc">{deal.description}</p>}
              <p className="vc-deal-card__meta">{formatDealMeta(deal)}</p>
            </div>
          </article>
        ))}
      </div>
      <p className="vc-deal-cards__note">{BILLING_NOTE}</p>
    </div>
  );
};

export default CaptainDealCards;
